import React from "react";
import { ArrowSquareOut, CheckCircle, XCircle } from "@phosphor-icons/react";
import { previewUrl } from "@/components/thankyou/ThankYouPreviewDialog";

const capText = (c) => [c.daily_cap ? `${c.today}/${c.daily_cap} today` : `${c.today} today`,
  c.monthly_cap ? `${c.this_month}/${c.monthly_cap} this month` : null].filter(Boolean).join(" · ");

export function TryLeadResult({ res }) {
  const b = res.buyer;
  return (
    <div className="mt-4 space-y-3" data-testid="try-lead-result">
      {b ? (
        <div className="flex flex-wrap items-start gap-3 border-2 border-emerald-700 bg-emerald-50 p-3" data-testid="try-lead-buyer">
          <CheckCircle size={22} weight="fill" className="text-emerald-700" />
          <div className="min-w-0 flex-1">
            <div className="text-sm font-bold">Goes to {b.name}</div>
            <div className="text-xs text-zinc-700">
              {res.source === "link" ? "From this buyer's own link." : "Matched on state, accident type and answers."} The visitor sees {b.name}&apos;s thank-you page.
            </div>
          </div>
          <a href={previewUrl(b.code, res.funnel)} target="_blank" rel="noopener noreferrer" data-testid="try-lead-ty-preview"
             className="inline-flex items-center gap-1 border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest transition-colors duration-100 hover:bg-black hover:text-white">
            Preview thank-you page <ArrowSquareOut size={12} />
          </a>
        </div>
      ) : (
        <div className="flex items-start gap-3 border-2 border-red-700 bg-red-50 p-3" data-testid="try-lead-none">
          <XCircle size={22} weight="fill" className="text-red-700" />
          <div className="text-xs text-red-900">
            <div className="text-sm font-bold">No buyer would take this lead</div>
            It would go to your other delivery rules, then the marketplace, and show the standard thank-you page. It would appear under &quot;Leads no buyer took&quot; on this page.
          </div>
        </div>
      )}
      {res.candidates.length > 0 && (
        <div data-testid="try-lead-candidates">
          <div className="label-mono mb-1">Buyers that match ({res.candidates.length})</div>
          <ul className="divide-y divide-zinc-200 border border-black text-xs">
            {res.candidates.map((c) => (
              <li key={c.code} className="flex flex-wrap items-center gap-2 px-2 py-1.5">
                <span className="font-bold">{c.name}</span>
                <span className="text-zinc-600">{capText(c)}</span>
                {c.capped && <span className="ml-auto bg-red-700 px-1.5 py-0.5 text-[9px] uppercase tracking-widest text-white">Capped</span>}
                {b && c.code === b.code && <span className="ml-auto bg-emerald-700 px-1.5 py-0.5 text-[9px] uppercase tracking-widest text-white">Gets it</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
      {res.skipped.length > 0 && (
        <details data-testid="try-lead-skipped">
          <summary className="label-mono cursor-pointer">Why other live buyers don&apos;t match ({res.skipped.length})</summary>
          <ul className="mt-1 divide-y divide-zinc-200 border border-black text-xs">
            {res.skipped.map((s) => <li key={s.code} className="px-2 py-1.5"><b>{s.name}</b> — {s.reason}</li>)}
          </ul>
        </details>
      )}
    </div>
  );
}
